// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    PrescriberSiteListPostRequest,
    PrescriberSiteSearchPostRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class SiteV2Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param prescriberSiteId generated
     * @param applicationContext generated
     * @param roleType generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async prescriberSiteGet (prescriberSiteId: string, applicationContext?: string, roleType?: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/site/v2/PrescriberSite/{prescriberSiteId}'
            .replace('{' + 'prescriberSiteId' + '}', encodeURIComponent(String(prescriberSiteId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberSiteId' is not null or undefined
        if (prescriberSiteId === null || prescriberSiteId === undefined) {
            throw new Error('Required parameter prescriberSiteId was null or undefined when calling prescriberSiteGet.');
        }

        if (applicationContext !== undefined) {
            _params_['applicationContext'] = Serializer.serialize(applicationContext, "string");
        }

        if (roleType !== undefined) {
            _params_['roleType'] = Serializer.serialize(roleType, "string");
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param id generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param prescriberSiteListPostRequest 
     */
    public async prescriberSiteList (id: string, xTcScopeid?: string, xTcScopetype?: string, prescriberSiteListPostRequest?: PrescriberSiteListPostRequest): Promise<AxiosResponse<object>> {
        const _url_ = '/site/v2/PrescriberSiteList/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling prescriberSiteList.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSiteListPostRequest, "PrescriberSiteListPostRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param prescriberSiteSearchPostRequest 
     */
    public async prescriberSiteSearch (xTcScopeid?: string, xTcScopetype?: string, prescriberSiteSearchPostRequest?: PrescriberSiteSearchPostRequest): Promise<AxiosResponse<object>> {
        const _url_ = '/site/v2/PrescriberSiteSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSiteSearchPostRequest, "PrescriberSiteSearchPostRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param prescriberId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async sitesByPrescriberGetByTenantId3 (prescriberId: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/site/v2/SitesByPrescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling sitesByPrescriberGetByTenantId3.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
}
